import React, { useEffect, useState } from 'react';
import logo from './favicon.ico';
import './App.css';
import seedData from './seeds.json';
import SeedLine from './components/SeedLine';
import seedlist03172024 from './documents/seedlist03172024.pdf';
import bracketpdf0312 from './documents/bracket03122023.pdf';

function App() {
  const [seeds, setSeeds] = useState([]);
  const lastUpdated = "February 8th, AM";

  useEffect(() => {
    // Load seed data
    setSeeds(seedData);
  }, []);

  // Original helper function to get the team's logo based on the team name.
  // It uses the team name (as a string) without any modifications for spaces.
  const getTeamLogo = (team) => {
    if (!team || team.toUpperCase() === "TBD") {
      return null;
    }
    try {
      // Dynamic require based on team name (assumes file names are lowercase)
      return require(`./logos/${team.toLowerCase()}.png`);
    } catch (error) {
      console.error(`Logo not found for team: ${team}`, error);
      return null;
    }
  };

  if (seeds.length === 0) {
    return <p>Loading seed data...</p>;
  }

  return (
    <div className="base">
      {/* Header Section */}
      <header className="app-header">
        <img src={logo} alt="App Logo" className="app-logo" />
        <div>
          <h1 id="title">Glazewski-tology</h1>
          <p id="last-updated">Last updated: {lastUpdated}</p>
        </div>
      </header>

      {/* Key Section */}
      <div id="key" style={{ textAlign: 'center', margin: '20px 0' }}>
        <span className="autobid-highlight">Automatic Bid</span>
      </div>

      {/* Content Section */}
      <div id="container">
        {seeds.map((seedData, index) => (
          <div key={index} className="seed-card">
            <h3>{seedData.seed}</h3>
            <ul>
              {seedData.teams.map((teamObj, i) => {
                // Use the team's name from the object for logo lookup.
                const teamLogo = getTeamLogo(teamObj.name);
                return (
                  <li key={i} className="team-item">
                    {teamLogo ? (
                      <div className="team-logo-container">
                        <img
                          src={teamLogo.default || teamLogo}
                          alt={`${teamObj.name} logo`}
                          className="team-logo"
                        />
                      </div>
                    ) : (
                      <div className="team-logo-container"></div>
                    )}
                    <span className="team-name">
                      <span className={`team-name ${teamObj.autobid ? 'autobid-highlight' : ''}`}>
                        {teamObj.name}
                      </span>
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>

      {/* Footer Section */}
      <footer className="app-footer">
      <p>
        <a
          href="mailto:glazewskic@gmail.com"
          style={{ color: 'black' }}
        >
          <strong>Contact: glazewskic@gmail.com</strong>
        </a>
      </p>
      </footer>
    </div>
  );
}

export default App;
